<ng-container *ngIf="!showAll && headers?.length > 0">
  <div class="row-item {{header.class}} {{header?.format}}" *ngFor="let header of headers" [attr.data-key]="header.key">
    <ng-container *ngIf="( header?.lockedInFreemium && isFreemium ) || header?.lock?.call()">
      <div class='freemium-lock'>
        <i class='fa fa-lock'></i>
      </div>
    </ng-container>
    <ng-container *ngIf="( !header?.lockedInFreemium || !isFreemium ) && !header?.lock?.call()">
      <ng-container *ngIf="item[header.key+'Template'] || (!item[header.key+'Template'] && !header?.format)">
        <ng-container *ngIf="item[header.key+'HREF']">
          <a class="item" (click)="goToClick(header.key, item[header.key])" target="_blank">
            <ng-container *ngIf='item[header.key + "Template"] != null'>
              <ng-container
                *ngTemplateOutlet='item[header.key + "Template"]; context: { row: item, item: item[header.key]}'></ng-container>
            </ng-container>
            <ng-container *ngIf='item[header.key + "Template"] == null'>
              <span>{{ item[header.key] }}</span>
            </ng-container>
          </a>
        </ng-container>

        <ng-container *ngIf="item[header.key+'RouterLink']">
          <a class="item" [routerLink]="item[header.key+'RouterLink']" [queryParams]="item[header.key+'QueryParams']">
            <ng-container *ngIf='item[header.key + "Template"] != null'>
              <ng-container
                *ngTemplateOutlet='item[header.key + "Template"]; context: { row: item, item: item[header.key]}'></ng-container>
            </ng-container>
            <ng-container *ngIf='item[header.key + "Template"] == null'>
              <span>{{ item[header.key] }}</span>
            </ng-container>
          </a>
        </ng-container>

        <ng-container *ngIf="!item[header.key+'HREF'] && !item[header.key+'RouterLink']">
          <span>
            <ng-container *ngIf='item[header.key + "Template"] != null'>
              <ng-container
                *ngTemplateOutlet='item[header.key + "Template"]; context: { row: item, item: item[header.key]}'></ng-container>
            </ng-container>
            <ng-container *ngIf='item[header.key + "Template"] == null'>
              <span>{{ item[header.key] }}</span>
            </ng-container>
          </span>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!item[header.key + 'Template'] && header?.format">
        <ng-container *ngIf="header?.format === 'percent'">
          <div class="height-100 align-items-center d-inline-flex" enAnonLock>
            {{item[header.key] | perc:'1.2-2'}}
          </div>
        </ng-container>
        <ng-container *ngIf="header?.format === 'percentRating'">
          <div class="height-100 align-items-center d-inline-flex" enAnonLock>
            <risk-heat-meter [risk]='item[header.key + "Rating"]'></risk-heat-meter>
          </div>
        </ng-container>
        <ng-container *ngIf="header?.format === 'percentbar'">
          <div class="main-cont d-inline-flex" enAnonLock>
            <div class="progress-bar-cont d-inline-block" *ngIf="maxValueMapping && maxValueMapping[header.key]">
              <div class="progress" [style.width]="((item[header.key] / maxValueMapping[header.key] ) * 100) + '%'">
                {{item[header.key] | perc:'1.2-2'}}
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="header?.isCollapse === 'true' && subHeaders?.length > 0 && item?.subDataTables?.length > 0">
      <a class="btn btn-link" data-toggle="collapse" [attr.href]="'#collapse'+id+index" aria-expanded="false"
        [attr.aria-controls]="'collapse'+id+index">
        <i class="fa fa-chevron-down"></i>
        <i class="fa fa-chevron-up"></i>
      </a>
    </ng-container>

  </div>
</ng-container>